<template lang="pug">
    .album-image(ref="container")
        a(href="#" @click.prevent="handleClick")
            img(:src="image.src")
</template>
<script>
import { get, trim, debounce, startsWith } from "@/helpers";
import router from "@/router";

export default {
  name: "AlbumImage",
  data() {
    return {
      maxWidth: 300
    };
  },
  props: {
    content: {
      type: Object,
      required: true
    }
  },
  computed: {
    hyperlink() {
      return get(this.content, "hyperlink", false);
    },
    image() {
      const image = get(this.content, "images.0");
      if (!image) return false;

      const storageRoute = trim(
        `${process.env.VUE_APP_API_HTTP}${process.env.VUE_APP_API_ENDPOINT}${process.env.VUE_APP_API_PUBLIC_STORAGE_ROUTE}`,
        "/"
      );

      let fit =
        get(image, "pivot.fit") || "fit=crop&crop=focalpoint&x=.5&y=.5&z=1";
      const parameters = {
        ...get(fit.match(/x=(?<fx>[0-1]?\.?[0-9]*)/), "groups"),
        ...get(fit.match(/y=(?<fy>[0-1]?\.?[0-9]*)/), "groups"),
        ...get(fit.match(/z=(?<fz>[1-9]+\.?[0-9]*)/), "groups"),
        ...get(fit.match(/w=(?<w>[0-9]+\.?[0-9]*)/), "groups"),
        ...get(fit.match(/h=(?<h>[0-9]+\.?[0-9]*)/), "groups")
      };
      let { w, h, fz } = parameters;

      let width, height, aspectRatio;

      width = image.width / fz;
      height = image.height / fz;
      aspectRatio = width / height;

      height = Math.min(window.innerWidth >= 1088 ? 400 : 140, height);
      width = height * aspectRatio;

      if (this.maxWidth < width) {
        height = this.maxWidth / aspectRatio;
        height = Math.min(window.innerWidth >= 1088 ? 400 : 140, height);
        width = height * aspectRatio;
      }

      if (w && h) {
        aspectRatio = w / h;

        height = Math.min(
          window.innerWidth >= 1088 ? 400 : 140,
          image.height / fz
        );
        width = height * aspectRatio;

        if (this.maxWidth < width) {
          height = this.maxWidth / aspectRatio;
          height = Math.min(
            window.innerWidth >= 1088 ? 400 : 140,
            image.height / fz
          );
          width = height * aspectRatio;
        }

        fit = fit
          .replace(/w=([0-9]+\.?[0-9]*)/, `w=${width}`)
          .replace(/h=([0-9]+\.?[0-9]*)/, `h=${height}`);
      } else if (!w && !h) {
        fit += `&h=${height}`;
      }

      return {
        src: `${storageRoute}/images/${image.id}/${image.name}?${fit}`,
        error: `${storageRoute}/images/${image.id}/${image.name}?${fit}&preview=greyscale`,
        loading: `${storageRoute}/images/${image.id}/${image.name}?${fit}&preview=blur`,
        width,
        height,
        aspectRatio
      };
    }
  },
  methods: {
    handleClick() {
      const content = this.content;
      const hyperlink = this.hyperlink;
      if (content && hyperlink) {
        const link = hyperlink.href;

        let href, target;
        const path = get(hyperlink, "menuItem.path");

        switch (hyperlink.type) {
          case "internal":
            if (path) {
              router.push({ path });
              return;
            }
            break;
          case "external":
            if (!startsWith(link, "https://") && !startsWith(link, "https://"))
              href = `https://${link}`;
            else href = link;
            target = hyperlink.target || "_self";
            break;
          case "mailto":
            href = `mailto:${link}`;
            target = "_self";
            break;
          case "tel":
            href = `tel:${link}`;
            target = "_self";
            break;
        }

        if (href) window.open(href, target);
      }
    }
  },
  mounted() {
    const calculateMaxWidth = () => {
      if (this.$refs.container) {
        const style = getComputedStyle(this.$refs.container);
        this.maxWidth = this.$refs.container.clientWidth;
        this.maxWidth -=
          parseFloat(style.paddingLeft) + parseFloat(style.paddingRight);
      }
    };

    window.addEventListener("resize", debounce(calculateMaxWidth, 100));
    calculateMaxWidth();
  }
};
</script>
<style lang="sass" scoped></style>
